export default {
  "languages": {
    "en": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["English"])},
    "it": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Italiano"])}
  },
  "labels": {
    "target-value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Obiettivo"])},
    "min-value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Min"])},
    "max-value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Max"])},
    "avg-value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Media"])},
    "cancel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annulla"])},
    "continue": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Continua"])},
    "update": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aggiorna"])},
    "back": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indietro"])}
  },
  "strings": {
    "chart-type": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tipo di grafico"])},
    "chart-type-subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seleziona un tipo di grafico"])},
    "chart-type-qualitative-hint": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Per i KPI qualitativi sono disponibili solo grafici categorici"])},
    "chart-category-distribution": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Distribuzione Categorie"])},
    "chart-target-category": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Categoria Target"])},
    "chart-categories": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Categorie"])},
    "chart-frequency": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Frequenza"])},
    "dashboard-kpi-visualization-chart": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Grafico di visualizzazione KPI"])},
    "dashboard-suggestion": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seleziona un tipo di grafico con cui desideri visualizzare i valori KPI"])}
  },
  "errors": {
    
  }
}